import React, { useState } from 'react'
import Table from 'react-bootstrap/Table'
import { InternalConflict } from 'shared/badges'
import { useConflictRoles } from 'api/hooks/use-conflict-roles'
import ConflictDetailsModal from 'duties/conflicts/tabs/ConflictDetailsModal'
import TableLoading from 'shared/tables/table-loading'
import TableFooter from 'shared/tables/table-footer'
import { getScoreDelta } from 'duties/score'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

function ConflictRoles({ conflict }) {
  const [selectedRole, setSelectedRole] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const defaultParams = {
    conflict_id: conflict.id,
    page: 1,
    perPage: 25
  }
  const [params, setParams] = useState(defaultParams)

  const { data: roles, isSuccess, isLoading } = useConflictRoles({ params })

  const handleRowClick = (role) => {
    setSelectedRole(role)
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedRole(null)
  }

  return (
    <>
      <Table size="sm" hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Conflicting Roles</th>
            <th>Internal</th>
            <th style={{ cursor: 'info' }}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    This shows how much the role score is impacted by the
                    conflict. External role conflicts are added together.
                  </Tooltip>
                }
              >
                <span>
                  Role Score Impact <FontAwesomeIcon icon={faInfoCircle} />
                </span>
              </OverlayTrigger>
            </th>
            <th>User Count</th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <TableLoading columns={5} />}
          {isSuccess &&
            roles.data.map((role) => (
              <tr
                key={`${role.id}-${role.conflict_role_id}`}
                onClick={() => handleRowClick(role)}
                style={{ cursor: 'pointer' }}
              >
                <td>{role.role_name}</td>
                <td>{role.conflict_role_name}</td>
                <td>
                  {role.is_internal && (
                    <InternalConflict textDisplay="Internal" className="ms-1" />
                  )}
                </td>
                <td>
                  <span className="text-danger">
                    +{' '}
                    {role.is_internal &&
                      getScoreDelta(
                        role.role_score,
                        role.raw_score_impact
                      ).toFixed(1)}
                    {!role.is_internal &&
                      (
                        getScoreDelta(role.role_score, role.raw_score_impact) +
                        getScoreDelta(
                          role.conflict_role_score,
                          role.raw_score_impact
                        )
                      ).toFixed(1)}
                  </span>
                </td>
                <td>
                  <span className="text-muted">{role.employee_count}</span>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      {isSuccess && (
        <ConflictDetailsModal
          show={showModal}
          onHide={handleCloseModal}
          role={selectedRole}
          conflictId={conflict.id}
        />
      )}
      {isSuccess && (
        <TableFooter meta={roles.meta} params={params} setParams={setParams} />
      )}
    </>
  )
}

export default ConflictRoles
